const colorModeToggle = document.querySelector('.color-mode-toggle');

if (colorModeToggle) {
	const theme = {
		dark: {
			'--background-color': '#000',
			'--foreground-color': '#fff',
		},
		light: {
			'--background-color': '#fff',
			'--foreground-color': '#000',
		},
	};

	// Use a separate function to update CSS properties
	function updateCSSProperties(themeChoice) {
		const root = document.documentElement;
		for (const [property, value] of Object.entries(theme[themeChoice])) {
			root.style.setProperty(property, value);
		}
	}

	function toggleTheme(e) {
		const themeChoice = e.target.checked ? 'dark' : 'light';
		updateCSSProperties(themeChoice);
		localStorage.setItem('theme', themeChoice);
	}

	// Initialize theme based on local storage preference
	const preferredTheme = localStorage.getItem('theme') || 'light';
	updateCSSProperties(preferredTheme);
	colorModeToggle.checked = preferredTheme === 'dark';

	colorModeToggle.addEventListener('change', toggleTheme, false);
}
